import { useContext } from "react";

//import { ReactComponent as ShoppingIcon } from "../../assets/shopping-bag.svg"; 

import { CartContext } from "../../contexts/cart.context";

import { CartIconContainer, ItemCount, ShoppingIcon } from './cart-icon.styles';

const CartIcon = () => {
    const { isCartOpen, setIsCartOpen, cartItemCount } = useContext(CartContext);
  
    const toggleIsCartOpen = () => setIsCartOpen(!isCartOpen);
  
    return (
      <CartIconContainer onClick={toggleIsCartOpen}>
        <ShoppingIcon className='shopping-icon' />
        <ItemCount>{cartItemCount}</ItemCount>
      </CartIconContainer>
    );
  };
  
  export default CartIcon;